import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import { chevron_down } from "../../../utils/images";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const AccountRedirectionCard = ({ item }) => {
  return (
    <View style={{ flexDirection: "column"}}>
      <View style={styles.text_card_blk_account}>
        <View
          style={{
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: 0,
            flex: 1,
          }}
        >
          <FormTextLabel labelStyles={styles.text_card_img_title} label={item?.title} />
          <FormTextLabel labelStyles={styles.text_card_img_subtitle} label={item?.subtitle} />
        </View>

        <FastImage style={styles.telegramImage} source={globalConfigurableData.right_arrow_black()} />
      </View>
    </View>
  );
};

export default AccountRedirectionCard;

const styles = StyleSheet.create({
  text_card_img_title: {
    ...globalFontStyle.appFontSubHeading,
    lineHeight: 21,

    color: globalConfigurableData.primaryTextColor1,
  },
  text_card_img_subtitle: {
    ...globalFontStyle.appFontSmallText,
    paddingTop: 2,
    color: globalConfigurableData.secondaryTextColor1,
  },

  text_card_img_parent_header: {
    width: 55,
    height: 55,
    // borderRadius: 55,
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "#F5F5F5",
  },

  text_card_blk_account: {
    backgroundColor: globalConfigurableData.globalThemeColor,
    margin: 0,
    flexDirection: "row",
    paddingVertical: 15,
    marginHorizontal: 20,
    alignItems: "center",
    alignContent: "space-around",
    borderBottomColor: globalConfigurableData.borderColor,
    borderBottomWidth: 0.75,
    flex: 1,
    justifyContent: "flex-start",
  },
  telegramImage: {
    width: 22,
    height: 22,
  },
});
